import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import BottomNavigation from "../Components/BottomNavigation";
import TopNavigation from "../Components/TopNavigation";
import SocialMediaPost from "../Components/SocialMediaPost";

const UserProfile = () => {
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUserName");
    window.location.href = "/login";
  };

  const [restaurants, setRestaurants] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const loaderRef = useRef(null);

  useEffect(() => {
    const fetchUserPosts = async () => {
      try {
        if (loaderRef.current) {
          loaderRef.current.style.display = "block"; // Show the loader
        }

        const token = localStorage.getItem("authToken");
        const response = await axios.get(
          "https://foodie-wirte.onrender.com/api/userpost",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const userPosts = response.data;
        console.log(userPosts);
        setRestaurants(userPosts);
        setDataLoaded(true); // Set dataLoaded to true after fetching the data

        if (loaderRef.current) {
          loaderRef.current.style.display = "none"; // Hide the loader
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchUserPosts();
  }, []);

  const currentUserName = localStorage.getItem("currentUserName");

  const profileImgs = [
    "Cali",
    "George",
    "Milo",
    "Bandit",
    "Sheba",
    "Kitty",
    "Baby",
    "Socks",
    "Jasper",
    "Snuggles",
    "Pumpkin",
    "Boo",
    "Peanut",
    "Zoe",
    "Scooter",
    "Annie",
    "Smokey",
  ];

  const rand = Math.floor(Math.random() * profileImgs.length);
  const randPic = profileImgs[rand];

  return (
    <div className="flex flex-col min-h-screen">
      <TopNavigation />
      <div className="flex flex-row items-start pt-20 space-x-2 ml-5">
        <div>
          <img
            src={`https://api.dicebear.com/6.x/pixel-art/svg?seed=${randPic}`}
            alt="User Profile"
            className="w-14 h-14 rounded-full"
          />
        </div>
        <div className="pt-1">
          <h1 className="text-base font-bold">Welcome,</h1>
          <h1>
            <span className="text-2xl font-bold tracking-wide">
              {currentUserName}
            </span>
          </h1>
        </div>
      </div>
      <div className="flex flex-col flex-grow items-center justify-center pt-10 pb-20 px-1">
        {dataLoaded ? (
          <>
            {restaurants.length > 0 ? (
              <div className="space-y-10">
                {restaurants.map((restaurant) => {
                  const randomIndex = Math.floor(
                    Math.random() * profileImgs.length
                  );
                  const randomProfileImg = profileImgs[randomIndex];

                  const u_name =
                    restaurant && restaurant.userName
                      ? restaurant.userName
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")
                      : "";

                  return (
                    <SocialMediaPost
                      key={restaurant._id}
                      userName={u_name}
                      splDish={restaurant.splDish}
                      restaurantName={restaurant.restaurantName}
                      img={restaurant.img}
                      cost={restaurant.cost}
                      rating={restaurant.rating}
                      profilePic={`https://api.dicebear.com/6.x/pixel-art/svg?seed=${randomProfileImg}`}
                      postId={restaurant._id}
                      className="mr-4 mb-4"
                    />
                  );
                })}
              </div>
            ) : (
              <div className="text-gray-600 text-lg font-semibold mb-4">
                No posts available.
              </div>
            )}
          </>
        ) : (
          <div
            ref={loaderRef}
            className="w-12 h-12 animate-spin rounded-full border-4 border-solid border-red-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            style={{ display: "none" }}
          ></div>
        )}

        {dataLoaded && (
          <button
            onClick={handleLogout}
            className="px-5 py-1 text-xs bg-red-600 text-white rounded-md hover:bg-red-700 mt-10"
          >
            Logout
          </button>
        )}
      </div>
      <BottomNavigation />
    </div>
  );
};

export default UserProfile;
